module.exports = __webpack_public_path__ + "static/subpages-affordability-tablet.f9de8b86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tablet/subpages-affordability-tablet.jpg
// module id = 599
// module chunks = 126523225082832